import { createFileRoute } from '@tanstack/react-router';
import { AdminAnnouncements } from '../../components/admin/admin-announcements';

export const Route = createFileRoute('/admin/announcements')({
  component: AdminAnnouncements,
});
